<template lang="pug">
#contact_us
  custom-header(
    :title="contactUsPage.area01_Title",
    :subTitle="contactUsPage.area01_SubTitle",
    :image="contactUsPage.area01_Image",
    :buttonName="contactUsPage.area01_ButtonName",
    :buttonURL="contactUsPage.area01_ButtonURL"
  )

  section.container-fluid.bg_blue.i_ptb_10
    .container.custom_container_md.form
      h2.i_h2_title.text-center 意見內容
      p.i_content.text-center 為更有效率的回應您的問題，
        span.d-block.d-md-inline-block 敬請完整填寫以下基本資料與內容
      .row.i_mt_14
        .col-12
          label.form_label 您的姓名
          input.input_text(type="text", placeholder="請輸入您的姓名", v-model="name")
        .col-12.i_mt_8
          label.form_label 電子信箱
          input.input_text(
            type="text",
            placeholder="請輸入您的電子信箱",
            v-model="email"
          )
        .col-12.i_mt_8
          label.form_label 聯絡電話
          input.input_text(
            type="text",
            placeholder="建議以行動電話號碼為主",
            v-model="phone"
          )
        .col-12.i_mt_6.flex_h.align-items-start
          label.form_label.selector 聯絡時間
          .selector_btn(
            :class="{ selected: time == '上午' }",
            @click="time = '上午'"
          ) 上午
          .selector_btn(
            :class="{ selected: time == '下午' }",
            @click="time = '下午'"
          ) 下午
        .col-12.i_mt_4.flex_h.align-items-start
          label.form_label.selector.multiple 意見類別
          .selectors.flex_h.align-items-start
            .selector_btn(
              v-for="(opinionDetail, index) in contactUsPage.area02_OpinionList",
              :key="index",
              :class="{ selected: opinion.includes(opinionDetail.area02_OpinionList_ID) }",
              @click="opinionClick(opinionDetail)"
            ) {{ opinionDetail.area02_OpinionList_Name }}
        .col-12.i_mt_4.flex_h.align-items-start
          label.form_label.selector 商品種類
          .selectors.flex_h.align-items-start
            .selector_btn(
              v-for="(productCategoryDetail, index) in productCategory.ProductCategoryList",
              :key="index",
              :class="{ selected: product.ProductCategoryID == productCategoryDetail.ProductCategoryID }",
              @click="product = productCategoryDetail"
            ) {{ productCategoryDetail.ProductCategoryName }}
        .col-12.i_mt_8.flex_h
          label.form_label 主旨
          input.input_text.title(type="text", v-model="subject")
        .col-12.i_mt_3.flex_h.align-items-start.note
          label.form_label
          p {{ contactUsPage.area02_Remarks }}
        .col-12.i_mt_3.flex_h.align-items-start
          label.form_label 您的意見
          textarea.input_text(type="text", v-model="opinionContent")
  .container-fluid.i_ptb_10
    .container.custom_container_md.form
      .row
        .col-12.col-md-auto.verify
          label.form_label 輸入驗證碼
          input.input_text(type="text", v-model="identifyCode")
        .col-12.col-md-auto.verify.d-flex.align-items-center.i_mt_sm_4
          .refresh_code_btn.d-flex.align-items-center.justify-content-center.justify-content-sm-end
            img.verify_code(:src="identifyCodeUrl")
            img.i_ml_4(@click="refreshCode")
            span.i_ml_1(@click="refreshCode") 重新產生驗證碼
    .container.custom_container_md
      .row
        .terms_wrapper.i_mlr_auto
          .terms.i_mt_11.i_plr_6.i_ptb_6
            pre.i_body(v-html="contactUsPage.area02_PersonInformation")
          .details.d-flex.justify-content-between.i_mt_4
            .check.d-flex
              input(type="checkbox", v-model="checkBtnStatus")
              span.i_body.i_ml_2 我已閱讀並同意《新安東京海上產險履行個人資料保護法告知義務內容》
            a.download_btn.d-flex.align-items-center.flex-shrink-0(
              :href="contactUsPage.area02_PersonInformation_FileURL",
              target="_blank"
            )
              svg-icon(iconClass="ic_download", className="icon")
              span 下載
      .row.justify-content-center.i_mt_10
        .btn_round.btn_border_blue_ci(@click="resetData") 清除表單
        .btn_round.btn_yellow(@click="confirm") 確認送出
</template>

<script>
import CustomHeader from "@/components/customer_service/Header";
import { getContactUsPage } from "@/json/customer_service";
import { getProductCategory } from "@/json/product";
import { sendContactUs } from "@/api/contact";

export default {
  name: "CustomerServiceContactUsPage",
  metaInfo() {
    return {
      title: this.contactUsPage.SEO_Title,
      meta: [
        { name: "description", content: this.contactUsPage.SEO_Description },
      ],
    };
  },
  components: {
    "custom-header": CustomHeader,
  },
  data() {
    return {
      contactUsPage: {},
      productCategory: [],
      name: "",
      email: "",
      phone: "",
      time: "",
      opinion: [],
      product: "",
      subject: "",
      opinionContent: "",
      identifyCode: "",
      identifyCodeUrl:
        process.env.BASE_URL + "api/contactus/captcha?" + new Date().getTime(),
      checkBtnStatus: false,
    };
  },
  created() {
    window.location.replace("https://www.tmnewa.com.tw/b2c_v2/commonweb/OfficialInfo/ContactUs.aspx")
    this.getContactUsPage();
    this.getProductCategory();
  },
  methods: {
    getContactUsPage() {
      getContactUsPage().then((response) => {
        this.contactUsPage = response.data;
      });
    },
    getProductCategory() {
      getProductCategory().then((response) => {
        this.productCategory = response.data;
      });
    },
    opinionClick(data) {
      if (this.opinion.includes(data.area02_OpinionList_ID)) {
        this.opinion = this.opinion.filter(
          (e) => e !== data.area02_OpinionList_ID
        );
      } else {
        this.opinion.push(data.area02_OpinionList_ID);
      }
    },
    refreshCode() {
      this.identifyCodeUrl =
        process.env.BASE_URL + "api/contactus/captcha?" + new Date().getTime();
    },
    checkData() {
      if (
        this.name == "" ||
        this.email == "" ||
        this.phone == "" ||
        this.time == "" ||
        this.subject == "" ||
        this.opinionContent == "" ||
        this.opinion.length == 0 ||
        this.product == "" ||
        this.identifyCode == "" ||
        this.checkBtnStatus == false
      ) {
        alert(
          "請填寫所有資料並且閱讀並同意《新安東京海上產險履行個人資料保護法告知義務內容》"
        );
        return false;
      }
      return true;
    },
    resetData() {
      this.name = "";
      this.email = "";
      this.phone = "";
      this.time = "";
      this.subject = "";
      this.opinionContent = "";
      this.opinion = [];
      this.product = "";
      this.identifyCode = "";
      this.checkBtnStatus = false;
      this.refreshCode();
    },
    confirm() {
      if (!this.checkData()) {
        return;
      }

      let tempOpinion = "";
      for (let index in this.opinion) {
        let temp = this.opinion[index];
        tempOpinion = tempOpinion + temp;
        if (index != this.opinion.length - 1) {
          tempOpinion = tempOpinion + ",";
        }
      }
      let data = {
        Captcha: this.identifyCode,
        Name: this.name,
        EMail: this.email,
        Phone: this.phone,
        Time: this.time,
        Types: tempOpinion,
        Products: this.product.ProductCategoryID,
        Subject: this.subject,
        Content: this.opinionContent,
      };
      sendContactUs(data)
        .then((response) => {
          if (response.data.Status) {
            this.resetData();
            alert(
              "感謝您的留言! 新安東京海上產險已收到您的來信，我們將會盡快回覆您的建議或問題."
            );
          } else {
            alert(response.data.Message);
          }
        })
        .catch(() => {
          alert("伺服器錯誤，請洽管理人員");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/customer_service/contact_us";
</style>
